import React from 'react';

const CloseIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 17.2637L17.2635 1.00022" stroke="#434343" strokeWidth="1.3" />
    <path d="M1 1L17.2635 17.2635" stroke="#434343" strokeWidth="1.3" />
  </svg>
);

export default CloseIcon;
